import React from 'react'

import { InputDropdown } from '@caudena/core/ui-kit'
import { SurfaceContainer } from '@caudena/core/ui-kit'
import { RadioMenu } from '@caudena/core/ui-kit'

import { FieldProps } from './types'

const inputIncludesOptions = [
  {
    label: 'True Positive',
    value: 'true',
  },
  {
    label: 'False Positive',
    value: 'false',
  },
  {
    label: 'All resolved',
    value: 'both',
  },
]

const ClosureStatus = ({ value, onChange }: FieldProps<string>) => {
  const handleInputClear = () => {
    onChange(undefined)
  }

  const inputDropdownValue = value
    ? inputIncludesOptions.find((o) => o.value === value)?.label || ''
    : ''

  return (
    <InputDropdown
      clearable
      padded={false}
      variant="outline"
      startAddon={{ label: 'Resolved:' }}
      placeholder="Any"
      value={inputDropdownValue}
      onClear={handleInputClear}
      sameWidth
    >
      <SurfaceContainer spaces={'md'}>
        <RadioMenu
          value={value}
          options={inputIncludesOptions}
          onChange={onChange}
        />
      </SurfaceContainer>
    </InputDropdown>
  )
}

export default ClosureStatus
